import axios from "axios";

/**
 * Obtém as URLs da API baseadas no ambiente
 * Em desenvolvimento: usa localhost com portas diferentes
 * Em produção: usa subdomínios separados para cada unidade
 * @returns {Object} Objeto com CAMPINA_API e PATOS_API
 */
const getApiUrls = () => {
  // Em desenvolvimento, usar localhost
  if (process.env.NODE_ENV === 'development') {
    return {
      CAMPINA_API: "http://localhost:3001/api",
      PATOS_API: "http://localhost:3002/api",
    };
  }
  
  // Em produção, usar subdomínios separados
  return {
    CAMPINA_API: "https://campina.colegioautentico.app.br/api",
    PATOS_API: "https://patos.colegioautentico.app.br/api",
  };
};

const { CAMPINA_API, PATOS_API } = getApiUrls();
export { CAMPINA_API, PATOS_API };

export const createApiInstance = () => {
  const storageData = sessionStorage.getItem("loggedUser");
  let user = null;

  if (storageData) {
    try {
      user = JSON.parse(storageData);
    } catch {
      user = null;
    }
  }

  const isCampina = user?.unit === "CAMPINA GRANDE";

  // Usa a URL hardcoded baseada na unidade
  const BASE_URL = isCampina ? CAMPINA_API : PATOS_API;

  const instance = axios.create({
    baseURL: BASE_URL,
    timeout: 300000, // 5 minutos para uploads grandes
    maxContentLength: 500 * 1024 * 1024, // 500MB
    maxBodyLength: 500 * 1024 * 1024, // 500MB
  });

  // Adicionar token de autenticação automaticamente
  instance.interceptors.request.use(
    (config) => {
      const token = user?.token || null;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return instance;
};
